/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Index_Description_BottomInputs */

const en_index_description_bottom = /** @type {(inputs: Index_Description_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

/**
* | output |
* | --- |
* | "" |
*
* @param {Index_Description_BottomInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const index_description_bottom = /** @type {((inputs?: Index_Description_BottomInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Index_Description_BottomInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_index_description_bottom(inputs)
});